export const Copy = (props) => (
  <svg
    style={{ ...props?.style }}
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className='copyIcon'
  >
    <path
      d='M10 3H4C3.44772 3 3 3.44772 3 4V11H4V4H10V3ZM6 5C5.44772 5 5 5.44772 5 6V12C5 12.5523 5.44772 13 6 13H12C12.5523 13 13 12.5523 13 12V6C13 5.44772 12.5523 5 12 5H6ZM12 12H6V6H12V12Z'
      fill='#94A3B8'
    />
  </svg>
);
